import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faDownload, faSync } from '@fortawesome/pro-light-svg-icons'

import { Button, Tools } from '@domain-group/suit-theme'

import { useSetState } from '@domain-group/react-hooks'

import handleCallbackAction from '@functions/handleCallbackAction'

import useCurrentUser from '@hooks/useCurrentUser'
import useFlipperKey from '@hooks/useFlipperKey'
import type { UseInvoicePayload } from '@hooks/useInvoice'
import useInvoiceItem from '@hooks/useInvoiceItem'

import AuthenticatedDownload from '@components/AuthenticatedDownload'

const defaultState = {
  loading: false,
}

type EditInvoiceToolsProps = {
  invoicePayload: UseInvoicePayload,
}

const EditInvoiceTools = (props: EditInvoiceToolsProps) => {
  const { invoicePayload } = props

  const [state, setState] = useSetState(defaultState)
  const { loading } = state

  const {
    callbacks: {
      syncExternalInvoice: syncFn,
    },
    downloadUrl,
    invoice,
    invoice: { approved, id, void: isVoid },
  } = invoicePayload

  const invoiceItemPayload = useInvoiceItem({ invoice_id: id })

  const isSynced = !!invoice.data?.xero_id || false

  const { isProviderUser } = useCurrentUser()
  const canViewDownloadButton = !!isProviderUser

  const {
    callbacks: {
      createOrEditInvoiceItem,
    },
  } = invoiceItemPayload

  const shouldShowActionButton = !approved && !isVoid

  const syncExternalInvoice = {
    callbacks: {
      action: syncFn,
      afterAction: () => setState({ loading: false }),
      afterError: () => setState({ loading: false }),
    },
    toastText: 'Invoice Synced',
  }

  return (
    <Tools>
      {canViewDownloadButton && (
        <AuthenticatedDownload>
          <Button
            // @ts-expect-error TS2322
            as="a"
            buttonStyle="secondaryUtility"
            href={downloadUrl}
            icon={<FontAwesomeIcon icon={faDownload} />}
            size="medium"
          >
            Download PDF
          </Button>
        </AuthenticatedDownload>
      )}

      {shouldShowActionButton && (
        <Button
          buttonStyle="secondaryUtility"
          icon={<FontAwesomeIcon icon={faPlus} />}
          // @ts-expect-error TS2322
          marginTop={canViewDownloadButton ? 'medium' : 'none'}
          onClick={() => createOrEditInvoiceItem()}
          size="medium"
        >
          Add Invoice Item
        </Button>
      )}

      {isSynced && approved && (
        <Button
          buttonStyle="secondaryUtility"
          icon={<FontAwesomeIcon icon={faSync} />}
          // @ts-expect-error TS2322
          marginTop="medium"
          loading={loading}
          onClick={() => {
            setState({ loading: true })
            // @ts-expect-error TS2345
            handleCallbackAction(syncExternalInvoice)
          }}
          size="medium"
        >
          Sync
        </Button>
      )}
    </Tools>
  )
}

export default EditInvoiceTools
